






































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
    import Barcode from "../../components/bar-code.vue";
 import _ from "lodash"
import TransferOrder from '../../../store/entities/transfer-orders/transfer-order'
import Print from 'vue-print-nb'
Vue.use(Print);
@Component({
    components:{ 'barcode': Barcode}
})
export default class TransferOrderReceipt extends AbpBase{
  @Prop({ type: Boolean, default: false }) value: boolean;

    currentDate: Date = new Date();
    transferOrder:TransferOrder=new TransferOrder();
    id : number = 0;
    vloading :boolean= false;
    sumOrderQty : number=0;
    sumReceivedQty : number=0;
    sumPackedQty : number = 0;
    get transferOrderLines() {
        var re = this.transferOrder;
        var index = 0;
        if(re.items != undefined){
        re.items.forEach(function(item) {
            item.orderNo = index + 1;
            index++;
        });
        }
        return re.items;
    }
    get loading(){
        return this.vloading;
    }
    isNoPackText(){
        return this.transferOrder.isNoPack ? Util.L('NotPackedText'):Util.L('PackedText');
    }
    columns=[
        {
            title:Util.L('Order'),
            key:'orderNo',
            width:70
        },
        {
            title:Util.L('SKU'),
            key:'sku'
        },
        {
            title:Util.L('ProductName'),
            key:'productName'
        },
        {
            title:Util.L('OrderQty'),
            width: 100,
            key:'orderQty',
            align: "right",
            render: (h:any,params:any) =>{
                return h('span', Util.toViewNumberString(params.row.orderQty));
            }
        },
        {
            title:Util.L('PackedQty'),
            align: 'right',
            width: 100,
            key:'outPackedQty',
            render: (h:any,params:any) =>{
                return h('span', Util.toViewNumberString(params.row.outPackedQty));
            }
        },
        {
            title:Util.L('ReceivedQty'),
            width: 100,
            key:'inReceivedQty',
            align: "right",
            render: (h:any,params:any) =>{
                return h('span', Util.toViewNumberString(params.row.inReceivedQty));
            }
        }
    ]
      getSumQty()
        {
            if(this.transferOrderLines.length>0)
            {
                this.sumOrderQty =  _.sumBy(this.transferOrder.items,'orderQty');
                this.sumReceivedQty =  _.sumBy(this.transferOrder.items,'inReceivedQty');
                this.sumPackedQty =  _.sumBy(this.transferOrder.items,'outPackedQty');
            }
        }
    async created(){
        this.vloading = true;
        this.id = + this.$root.$router.currentRoute.params.id;
            await this.$store
                .dispatch({
                type: "transferOrder/get",
                data: { id: this.id }
                })
                .then(result => {
                this.transferOrder = result;
                this.getSumQty();
               this.vloading = false;
                });
    }
}
